import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi } from "./apiService";
import { handleApiError } from "./helpers";

/**
 * Loads merchants/stores from API with optional search filter
 * @param {string} search - Search query parameter (optional)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of merchants or null if error
 */
export const loadMerchantsData = async (search = '', notifyError) => {
    const searchParam = search ? `?search=${search}` : '';
    return await apiCall(
        `${url.GET_DASHBOARD_MERCHANTS}${searchParam}`,
        'GET',
        null,
        notifyError,
        "Failed to load stores"
    );
};

/**
 * Loads uninstalled merchants/stores from API
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of uninstalled merchants or null if error
 */
export const loadUninstalledMerchantsData = async (notifyError) => {
    return await apiCall(
        `${url.GET_DASHBOARD_MERCHANTS}?install_status=0`,
        'GET',
        null,
        notifyError,
        "Failed to load ex-stores"
    );
};

/**
 * Updates store Shopify Plus status
 * @param {Object} storeData - Store data (store_domain, is_shopify_plus)
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const updateStoreShopifyPlus = async (storeData, notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.PUT_UPDATE_STORE, 'PUT', storeData);

        if (response.ok) {
            notifySuccess("Shopify Plus updated successfully");
            return true;
        } else {
            handleApiError(response, results, notifyError);
            return false;
        }
    } catch (err) {
        notifyError("Failed to update Shopify Plus status. Please check your network connection.");
        return false;
    }
};

/**
 * Updates store Headless Store status
 * @param {Object} storeData - Store data (store_domain, is_headless_store)
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const updateStoreHeadlessStore = async (storeData, notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.PUT_UPDATE_STORE, 'PUT', storeData);

        if (response.ok) {
            notifySuccess("Headless Store updated successfully");
            return true;
        } else {
            handleApiError(response, results, notifyError);
            return false;
        }
    } catch (err) {
        notifyError("Failed to update Headless Store status. Please check your network connection.");
        return false;
    }
};

/**
 * Updates store blocked status
 * @param {Object} storeData - Store data (store_domain, is_blocked, reason)
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const updateStoreBlocked = async (storeData, notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.PUT_ADMIN_BLOCKED, 'PUT', storeData);

        if (response.ok) {
            notifySuccess("Store Blocked status updated successfully");
            return true;
        } else {
            handleApiError(response, results, notifyError);
            return false;
        }
    } catch (err) {
        notifyError("Failed to update Store Blocked status. Please check your network connection.");
        return false;
    }
};